// src/data/adjustmentOfStatusData.js
const adjustmentOfStatusData = {
    // ==================== الصفحة الرئيسية + الوصف العام ====================
    "adjustment-status": {
        hero: {
            badge: "Adjustment of Status",
            title: "Green Card through Adjustment of Status",
            subtitle: "Apply for your green card without leaving the United States"
        },
        content: `
      <section class="py-16 lg:py-24 bg-gray-50">
        <div class="max-w-7xl mx-auto px-6">
          <div class="text-center mb-16">
            <h2 class="text-4xl md:text-5xl font-black text-gray-900 mb-6">What Is Adjustment of Status?</h2>
            <p class="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              Adjustment of status is the process that allows certain immigrants already in the United States to apply for a green card 
              <strong>without having to leave the country</strong> and attend an interview at a U.S. embassy abroad.
            </p>
            <p class="text-xl text-gray-600 max-w-4xl mx-auto mt-8 leading-relaxed">
              If you’re outside the United States or don’t qualify for adjustment, your case will proceed through consular processing — 
              a similar but separate procedure handled abroad.
            </p>
          </div>

          <div class="bg-blue-900 text-white rounded-3xl p-16 text-center">
            <h3 class="text-4xl font-bold mb-6">Ready to Adjust Status from Inside the U.S.?</h3>
            <p class="text-2xl mb-10">Our complete package includes everything you need</p>
            <a href="/adjustment-of-status/i-485" class="inline-block bg-white text-blue-900 font-bold text-2xl px-16 py-6 rounded-xl hover:bg-gray-100 transition">
              Start Adjustment of Status Package →
            </a>
          </div>
        </div>
      </section>
    `
    },

    // ==================== I-485 Package ====================
    "i-485": {
        hero: {
            badge: "Form I-485",
            title: "Adjustment of Status Application",
            subtitle: "The most complete family-based green card package — biggest savings!"
        },
        price: "$279",
        savings: "Save $2,950 on average compared to an immigration attorney",
        packageName: "Adjustment of Status Package",
        forms: [
            "Form I-485, Application to Register Permanent Residence or Adjust Status",
            "Form I-130, Petition for Alien Relative (as needed)",
            "Form I-130A Supplement (as needed)",
            "Form G-1145, e-Notification of Application/Petition Acceptance",
            "Personalized instructions with a supporting document checklist",
            "Live support from citizenhup experts",
            "Guaranteed approval or your money back",
            "30% discount on additional forms required for your filing"
        ]
    },

    // ==================== I-864 Package ====================
    "i-864": {
        hero: {
            badge: "Form I-864",
            title: "Affidavit of Support",
            subtitle: "Prove financial ability to support your immigrant family member"
        },
        price: "$129",
        savings: "Save $950 on average compared to an immigration attorney",
        packageName: "Affidavit of Support Package",
        forms: [
            "Form I-864, Affidavit of Support",
            "Form I-864A, Contract Between Sponsor and Household Member (additional $25 per I-864A if needed)",
            "Personalized instructions with a supporting document checklist",
            "Live support from citizenhup experts",
            "Guaranteed approval or your money back"
        ]
    },

    // ==================== I-765 Package ====================
    "i-765": {
        hero: {
            badge: "Form I-765",
            title: "Employment Authorization (EAD)",
            subtitle: "Work legally in the U.S. while your green card is pending"
        },
        price: "$79",
        savings: "Save $350 on average compared to an immigration attorney",
        packageName: "Employment Authorization Package",
        forms: [
            "Form I-765, Application for Employment Authorization",
            "Form G-1145, e-Notification of Application/Petition Acceptance",
            "Personalized instructions with a supporting document checklist",
            "Live support from citizenhup experts",
            "Guaranteed approval or your money back"
        ]
    },

    // ==================== I-131 Package ====================
    "i-131": {
        hero: {
            badge: "Form I-131",
            title: "Advance Parole Travel Document",
            subtitle: "Travel abroad without abandoning your green card application"
        },
        price: "$99",
        savings: "Save $350 on average compared to an immigration attorney",
        packageName: "Travel Document Application Package",
        forms: [
            "Form I-131, Application for Travel Document",
            "Form G-1145, e-Notification of Application/Petition Acceptance",
            "Personalized instructions with a supporting document checklist",
            "Live support from citizenhup experts",
            "Guaranteed approval or your money back"
        ]
    },

    // ==================== Adjustment of Status Fee (الأخيرة محتوى عادي) ====================
    "adjustment-fee": {
        hero: {
            badge: "AOS Fees",
            title: "Adjustment of Status Fee",
            subtitle: "Complete breakdown of USCIS fees and how to save"
        },
        content: `
      <section class="py-16 lg:py-24 bg-gray-50">
        <div class="max-w-7xl mx-auto px-6">
          <div class="text-center mb-16">
            <h2 class="text-4xl md:text-5xl font-black text-gray-900 mb-6">Adjustment of Status Costs Explained</h2>
            <p class="text-xl text-gray-600 max-w-4xl mx-auto">
              Understand exactly what you'll pay to USCIS — and how citizenhup helps you save thousands compared to an attorney.
            </p>
          </div>

          <div class="bg-gradient-to-r from-blue-600 to-blue-800 text-white rounded-3xl p-16 text-center">
            <h3 class="text-4xl font-bold mb-6">Why Pay an Attorney $3,000+ When You Can Do It for $279?</h3>
            <a href="/adjustment-of-status/i-485" class="inline-block bg-white text-blue-800 font-bold text-2xl px-16 py-6 rounded-xl hover:bg-gray-100 transition">
              Start Full Adjustment Package for Only $279 →
            </a>
          </div>
        </div>
      </section>
    `
    }
};

export default adjustmentOfStatusData;